import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const PrivacyPolicy = () => {
    return (
        <Box sx={{ backgroundColor: "#e6f2ff", py: 6 }}>
            <Container>
                <Typography variant="h3" fontWeight="bold" align="center" gutterBottom>
                    Privacy Policy
                </Typography>
                <Typography variant="body1" paragraph>
                    At MC3 SmarTech, your privacy matters to us. This Privacy Policy outlines the information we collect, how we use it, and how we protect it when you visit our website or use our services. Please take a moment to review our policy.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    1. What Information We Collect
                </Typography>
                <Typography variant="body1" paragraph>
                    To improve your experience with our services, we collect the following types of information:
                </Typography>
                <Typography variant="body1" paragraph>
                    <ul>
                        <li>
                            <strong>Personal Information</strong>: This includes details like your name, email address, phone number, and payment information.
                        </li>
                        <li>
                            <strong>Usage Data</strong>: We collect data such as your IP address, browser type, device information, and how you interact with our services.
                        </li>
                        <li>
                            <strong>Cookies and Tracking Technologies</strong>: We use cookies to enhance your experience and improve our website's functionality. Cookies help us remember your preferences and track your activities across sessions.
                        </li>
                    </ul>
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    2. How We Use Your Information
                </Typography>
                <Typography variant="body1" paragraph>
                    We use the information we collect in the following ways:
                </Typography>
                <Typography variant="body1" paragraph>
                    <ul>
                        <li>To deliver and improve our services.</li>
                        <li>To personalize your experience and respond to your requests.</li>
                        <li>To process your transactions and manage payments.</li>
                        <li>To send important updates and promotional content.</li>
                        <li>To analyze how users interact with our website and services to enhance performance.</li>
                    </ul>
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    3. Sharing Your Information
                </Typography>
                <Typography variant="body1" paragraph>
                    We may share your personal information with the following entities:
                </Typography>
                <Typography variant="body1" paragraph>
                    <ul>
                        <li>
                            <strong>Service Providers</strong>: Third-party partners who assist us in delivering our services, such as payment processors and email service providers.
                        </li>
                        <li>
                            <strong>Legal Compliance</strong>: If required by law, we may share your information to comply with legal obligations or to protect our rights.
                        </li>
                        <li>
                            <strong>Business Transactions</strong>: In the event of a merger, acquisition, or sale of our business, your information may be transferred to the new owner.
                        </li>
                    </ul>
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    4. Keeping Your Data Safe
                </Typography>
                <Typography variant="body1" paragraph>
                    We take reasonable measures to protect your data from unauthorized access or misuse. However, please understand that no method of electronic transmission or storage is 100% secure, and we cannot guarantee complete security.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    5. Your Rights and Choices
                </Typography>
                <Typography variant="body1" paragraph>
                    You have the following rights regarding your personal data:
                </Typography>
                <Typography variant="body1" paragraph>
                    <ul>
                        <li>Access and update your personal information.</li>
                        <li>Request the deletion of your personal data, subject to certain legal requirements.</li>
                        <li>Opt out of receiving promotional emails from us.</li>
                        <li>Request a copy of your data in a machine-readable format.</li>
                    </ul>
                </Typography>
                <Typography variant="body1" paragraph>
                    To exercise any of these rights, simply contact us using the details provided below.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    6. Privacy for Children
                </Typography>
                <Typography variant="body1" paragraph>
                    Our services are not intended for children under 13 years old. We do not knowingly collect personal information from children. If we discover that we have collected data from a child under 13, we will delete it as soon as possible.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    7. Changes to This Privacy Policy
                </Typography>
                <Typography variant="body1" paragraph>
                    We may update this Privacy Policy from time to time. Any changes will be reflected on this page, and we will update the date of the last revision at the top of the page. We encourage you to review this policy periodically to stay informed of any updates.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    8. Contact Us
                </Typography>
                <Typography variant="body1" paragraph>
                    If you have any questions or concerns about how we handle your personal information, feel free to reach out to us at:
                </Typography>
                <Typography variant="body1" paragraph>
                    Email: <br />
                    Phone:
                </Typography>
            </Container>
        </Box>
    );
};

export default PrivacyPolicy;
